import { gql } from "@apollo/client";

// queries
export const UNIT_ONE_QUERY = gql`
	query One($filters: UnitQueryFilters) {
		units(filters: $filters) {
			one {
				name
				additionalFeatures
				ageStatus {
					value
				}
				amenities {
					images {
						name
						tags
					}
					name
				}
				salePrice
				confirmationStatus
				amenitiesCode
				approvalsStr
				builtUpArea
				documentsStr
				facing
				floor
				flooring
				floorplans
				floors {
					number
				}
				identifier
				images {
					original
					space
				}
				linkedLocalities
				locality
				location {
					gps {
						coordinates
					}
					locality
				}
				monthlyMaintenanceCost
				plotArea
				priceStr
				projectBlockData {
					maxFloors
					number
					numOfUnits
				}
				projectData {
					approvalsStr
					bankApprovalsStr
					id
					name
					status {
						possession
					}
					waterSource
				}
				rentalValue
				saleStatus
				slug
				spaceSummary {
					flooring
					furnishing
					furnishingMap {
						furnishings
						space
					}
					interiors
				}
				spaces {
					balconies {
						number
					}
					bathrooms {
						number
					}
					bedrooms {
						number
					}
					halls {
						number
					}
					kitchens {
						number
					}
					parkings {
						number
					}
					servantRooms {
						number
					}
					utilities {
						number
					}
				}
				waterSource
				propertyType {
					gated
					level
					penthouse
					project
					single
					type
					villa
					villaType
					villament
				}
				block {
					id
					name
				}
				flatNumber
				keyholderMobile
				keyholderName
				keyholderDesignation
				isSelfOccupied
				availabilitySlots {
					endTime
					startTime
				}
			}
		}
	}
`;
export const UNIT_LIST_QUERY = gql`
	query List($filters: UnitQueryFilters) {
		units(filters: $filters) {
			list {
				id
				name
				priceStr
				builtUpArea
				facing
				cover
				spaces {
					bathrooms {
						number
					}
					bedrooms {
						number
					}
				}
				plotArea
				propertyType {
					type
					single
					project
					penthouse
					level
					gated
					villa
					villaType
					villament
				}
				project {
					id
				}
			}
		}
	}
`;

export const UNIT_NEARBY_QUERY = gql`
	query Units($filters: UnitQueryFilters) {
		units(filters: $filters) {
			getNearbyUnits {
				cover
				project {
					name
					id
				}
				spaces {
					bathrooms {
						number
					}
					bedrooms {
						number
					}
				}
				facing
				plotArea
				builtUpArea
				location {
					locality
				}
				priceAnalysis {
					base {
						rate
						value
					}
				}
				propertyType {
					type
				}
			}
		}
	}
`;

export const UNIT_NEARBY_PROJECT = gql`
	query GetNearbyProjects($filters: UnitQueryFilters) {
		units(filters: $filters) {
			getNearbyProjects {
				id
				name
				cover
				localityName
				location {
					address
					gps {
						coordinates
					}
					city
					pin
				}
			}
		}
	}
`;

//mutations
export const UNIT_REQUEST_VISIT = gql`
	mutation UnitMethods($filters: UnitMethodFilters) {
		unitMethods(filters: $filters) {
			visitRequest {
				visitRequested
			}
		}
	}
`;

export const UNIT_SHORTLIST_MUTATION = gql`
	mutation UnitMethods($filters: UnitMethodFilters) {
		unitMethods(filters: $filters) {
			shortlist {
				_id
			}
		}
	}
`;

//To shorlist the suggestion collection property
export const UNIT_SUGGESTION_SHORTLIST_MUTATION = gql`
	mutation UnitMethods($filters: UnitMethodFilters) {
		unitMethods(filters: $filters) {
			shortlistUnit {
				_id
			}
		}
	}
`;

export const UNIT_REMOVE_SHORTLIST_MUTATION = gql`
	mutation UnitMethods($filters: UnitMethodFilters) {
		unitMethods(filters: $filters) {
			removeShortlist {
				_id
			}
		}
	}
`;
